import React, {useEffect, useState} from "react";
import styled from "@emotion/styled";
import useCurrency from "../hooks/useCurrency";
import useCryptoCurrency from '../hooks/useCryptocurrency';
import axios from 'axios';
import Error from './Error';


const Button = styled.input`
  margin-top: 20px;
  font-weight: bold;
  font-size: 20px;
  padding: 10px;
  background-color: #66a2fe;
  text-transform: uppercase;
  border: none;
  width: 100%;
  border-radius: 10px;
  color: #fff;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #326ac0;
    cursor: pointer;
  }
`;

const Form = ({updateCurrency, updateCrypto}) => {
    //state de lasta de cryptoCurrency
    const [listcrypto, setListCrypto] = useState([]);
    const [error, setError] = useState(false);
   
  const CURRENCY = [
    { code: "USD", name: "Dolar Estado Unidence" },
    { code: "MXN", name: "Peso Mexicano" },
    { code: "EUR", name: "Euro" },
    { code: "GBP", name: "Libra Esterlina" },
    { code: "COD", name: "Peso Colombiano" },
  ];
//utilizar useCurrency
  const [currrency, SelectCurrency ] = useCurrency(
    "Elige tu Moneda",
    "",
    CURRENCY
    );
    
    //utilizar useCryptoCurrency
    const [cryptocurrency, SelectCrypto] = useCryptoCurrency(
      "Elige tu Criptomoneda",
      "",
      listcrypto
    );

    useEffect(() => {
        const consultAppi = async () => {
            const url =
                "https://min-api.cryptocompare.com/data/top/mktcapfull?limit=10&tsym=USD";
            const answer = await axios.get(url);
            setListCrypto(answer.data.Data);
        }
        consultAppi();
        
    }, []);

    //cuando el usuario envia el form
    const quoteCurrency = e => {
        e.preventDefault();
        //validacion
        if (currrency === '' || cryptocurrency === '') {
            setError(true);
            return;
        }
        //pasar los datos al componente
        setError(false);
        updateCurrency(currrency);
        updateCrypto(cryptocurrency);
    }
  return (
      <form
         
      onSubmit={quoteCurrency}
      >
           {error ? <Error message='Todos los campos son Requeridos'/>: null}
          <SelectCurrency />
          <SelectCrypto />
      <Button type="submit" value="Calculate" />
    </form>
  );
};

export default Form;
